import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalEmailModel extends CanalModel {
  constructor({
    id = 0,
    canalId = 0,
    canalEmailTipoId = 0,
    canalImapSmtpId = 0,
    canalMicrosoftId = 0,
    statusId = 0,
    nome = '',
    descricao = '',
    contatoParaNotificarFalhasDeAutenticacao = '',
  } = {}) {
    super(canalId, nome, descricao, TiposDeCanaisEnum.Email)
    this.id = id
    this.canalEmailTipoId = canalEmailTipoId
    this.canalImapSmtpId = canalImapSmtpId
    this.canalMicrosoftId = canalMicrosoftId
    this.statusId = statusId
    this.contatoParaNotificarFalhasDeAutenticacao = contatoParaNotificarFalhasDeAutenticacao
  }
}
